import React, { useState } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Form,
  Pagination,
  NavLink,
} from "react-bootstrap";
import Fade from "react-reveal";
import { Link, generatePath } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Dummy from "../../../images/dummy.jpg";
import { deleteProduct } from "../../../redux/states/products/thunk";
import { toast } from "react-toastify";
import ConfirmDelete from "../../Common/Modals/ConfirmDelete";
import CustomPagination from "../../CustomPagination";

const Productcategory = (props) => {
  const tableData = useSelector((state) => state.products)?.allProducts;
  const { showButtonLoader } = useSelector((state) => state.products);
  const { filter, setFilter, totalPage, getProductList } = props;
  const dispatch = useDispatch();
  const { handleNextClick, handlePreviousClick } = props;
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedDtaForDelete, setSelectedDtaForDelete] = useState({});
  const navigate = useNavigate();

  const handleEditProducts = (dta) => {
    const path = generatePath("/products/:productId/:slug/edit", {
      productId: dta?._id,
      slug: dta?.slug,
    });
    navigate(path);
  };

  const showProductDetails = (dta) => {
    const path = generatePath("/productDetails/:productId/:slug", {
      productId: dta?._id,
      slug: dta?.slug,
    });
    navigate(path);
  };

  const deleteProducts = (dta) => {
    setSelectedDtaForDelete(dta);
    setShowConfirmModal(true);
  };

  const confirmDelete = () => {
    const val = {
      slug: selectedDtaForDelete?.slug,
    };
    dispatch(deleteProduct(val))
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        getProductList();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <Fade>
      <section className="Prodcut-section py-3">
        <Container fluid>
          <Row>
            <div className="TableFilters d-flex align-items-center justify-content-start gap-10 p-3 p-lg-4 flex-wrap">
              <div className="left d-flex align-items-center gap-10 flex-wrap">
                <div className="">
                  <h2 className="m-0 fw-bold heading">Products Details</h2>
                </div>
              </div>
              <div className="right d-flex align-items-center justify-content-end gap-10 flex-wrap btnWrpper">
                <div className="px-2">
                  <Button className="d-flex w-100 cstmShadow align-items-center justify-content-center rounded-pill ">
                    Categories
                    <span className="ms-2 icn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M10 5.83333C14.1421 5.83333 17.5 5.08714 17.5 4.16667C17.5 3.24619 14.1421 2.5 10 2.5C5.85786 2.5 2.5 3.24619 2.5 4.16667C2.5 5.08714 5.85786 5.83333 10 5.83333Z"
                          stroke="#9DA3BB"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.5 4.16663C2.5 6.02496 5.72583 9.72829 7.38 11.5041C7.9868 12.1473 8.32743 12.9965 8.33333 13.8808V18.3333L11.6667 16.6666V13.8808C11.6667 12.9966 12.0175 12.1516 12.62 11.5041C14.275 9.72829 17.5 6.02579 17.5 4.16663"
                          stroke="#9DA3BB"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                  </Button>
                </div>
                <div className="right d-flex align-items-center justify-content-end gap-10 flex-wrap btnWrpper border-2 ">
                  <Button
                    className="d-flex align-items-center justify-content-center gap-2 rounded-pill cstmShadow"
                    onClick={() => navigate("/products/add")}
                  >
                    <span className="ms-2 icn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g id="ant-design:plus-outlined">
                          <path
                            id="Vector"
                            d="M9.41406 2.96875H10.5859C10.6901 2.96875 10.7422 3.02083 10.7422 3.125V16.875C10.7422 16.9792 10.6901 17.0312 10.5859 17.0312H9.41406C9.3099 17.0312 9.25781 16.9792 9.25781 16.875V3.125C9.25781 3.02083 9.3099 2.96875 9.41406 2.96875Z"
                            fill="#9DA3BB"
                          />
                          <path
                            id="Vector_2"
                            d="M3.4375 9.25781H16.5625C16.6667 9.25781 16.7188 9.3099 16.7188 9.41406V10.5859C16.7188 10.6901 16.6667 10.7422 16.5625 10.7422H3.4375C3.33333 10.7422 3.28125 10.6901 3.28125 10.5859V9.41406C3.28125 9.3099 3.33333 9.25781 3.4375 9.25781Z"
                            fill="#9DA3BB"
                          />
                        </g>
                      </svg>
                    </span>
                    Add product
                  </Button>
                </div>
              </div>
            </div>

            <div className="table_products CommonTable p-lg-4 p-3">
              <div className="table-responsive">
                <table className="table">
                  <thead className="">
                    <tr>
                      <th className="border-0">Product Name</th>
                      <th className="border-0">Image</th>
                      <th className="border-0">Category</th>
                      <th className="border-0">Selling price</th>
                      <th className="border-0">Discounted price</th>
                      <th className="border-0">Quantity</th>
                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="fw-bold">{data?.name}</td>
                          <td className="border-0">
                            <div className="tabel_img p-0">
                              <img
                                src={
                                  data?.mainImgUrl ? data?.mainImgUrl : Dummy
                                }
                                alt=""
                                className="img-fluid w-100 h-100 object-fit-cover"
                              />
                            </div>
                          </td>
                          <td className="border-0">{data?.category}</td>
                          <td className="border-0">
                            {data?.currencySymbol}{" "}
                            {Number(data?.price).toFixed(2)}
                          </td>
                          <td className="border-0">
                            {data?.currencySymbol}{" "}
                            {Number(data?.discount).toFixed(2)}
                          </td>
                          <td className="border-0">{data?.totalQuantity}</td>

                          <td className="border-0">
                            <div className="d-flex align-items-center justify-content-between gap-10">
                              <Button
                                variant="transparent"
                                className="border-0 p-0"
                                onClick={() => handleEditProducts(data)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="19"
                                  viewBox="0 0 19 19"
                                  fill="none"
                                >
                                  <g id="edit">
                                    <path
                                      id="Vector"
                                      d="M8.5 1.20947H6.83333C2.66667 1.20947 1 2.87614 1 7.04281V12.0428C1 16.2095 2.66667 17.8761 6.83333 17.8761H11.8333C16 17.8761 17.6667 16.2095 17.6667 12.0428V10.3761"
                                      stroke="black"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      id="Vector_2"
                                      d="M12.7001 2.05936L6.13339 8.62602C5.88339 8.87602 5.6334 9.36769 5.5834 9.72602L5.22506 12.2344C5.09173 13.1427 5.7334 13.776 6.64173 13.651L9.15006 13.2927C9.50006 13.2427 9.99173 12.9927 10.2501 12.7427L16.8167 6.17602C17.9501 5.04269 18.4834 3.72602 16.8167 2.05936C15.1501 0.392691 13.8334 0.926024 12.7001 2.05936Z"
                                      stroke="black"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      id="Vector_3"
                                      d="M11.7583 3.00098C12.3166 4.99264 13.875 6.55098 15.875 7.11764"
                                      stroke="black"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                </svg>
                              </Button>
                              <Button
                                variant="transparent"
                                className="border-0 p-0"
                                onClick={() => deleteProducts(data)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                >
                                  <path
                                    d="M7.71062 5.81438e-09C8.4026 -4.53024e-05 9.06838 0.264707 9.57136 0.739946C10.0743 1.21518 10.3764 1.86488 10.4156 2.55576L10.4198 2.70914H14.796C14.9544 2.70918 15.1069 2.76936 15.2227 2.8775C15.3384 2.98563 15.4088 3.13368 15.4196 3.29171C15.4304 3.44974 15.3808 3.60598 15.2808 3.72885C15.1809 3.85173 15.038 3.93208 14.8811 3.95367L14.796 3.95951H14.1325L13.0655 14.8127C13.0121 15.3538 12.768 15.8583 12.377 16.236C11.9859 16.6138 11.4733 16.8403 10.9307 16.875L10.784 16.88H4.63721C4.09326 16.88 3.56705 16.6865 3.15261 16.3342C2.73816 15.982 2.46249 15.4938 2.37487 14.9569L2.3557 14.8119L1.28788 3.95951H0.625185C0.474109 3.9595 0.328146 3.90479 0.214288 3.80549C0.10043 3.70619 0.0263814 3.56902 0.00583504 3.41935L0 3.33432C6.37097e-06 3.18324 0.0547184 3.03728 0.154018 2.92342C0.253318 2.80957 0.390488 2.73552 0.54016 2.71497L0.625185 2.70914H5.00148C5.00148 1.99063 5.28691 1.30155 5.79497 0.793487C6.30303 0.285426 6.99211 5.81438e-09 7.71062 5.81438e-09ZM12.8763 3.95951H2.54409L3.60023 14.6894C3.62362 14.9288 3.72912 15.1527 3.89884 15.3232C4.06856 15.4937 4.29203 15.6002 4.53134 15.6246L4.63721 15.6296H10.784C11.2842 15.6296 11.7085 15.2754 11.8052 14.7944L11.8218 14.6894L12.8755 3.95951H12.8763ZM9.16938 6.25185C9.32046 6.25186 9.46642 6.30657 9.58028 6.40587C9.69414 6.50517 9.76819 6.64234 9.78873 6.79201L9.79457 6.87704V12.7121C9.79452 12.8705 9.73435 13.023 9.62621 13.1387C9.51807 13.2545 9.37003 13.3248 9.212 13.3356C9.05396 13.3464 8.89773 13.2968 8.77485 13.1969C8.65197 13.0969 8.57162 12.954 8.55003 12.7971L8.5442 12.7121V6.87704C8.5442 6.71123 8.61007 6.55221 8.72731 6.43496C8.84456 6.31772 9.00357 6.25185 9.16938 6.25185ZM6.25185 6.25185C6.40293 6.25186 6.54889 6.30657 6.66275 6.40587C6.77661 6.50517 6.85066 6.64234 6.8712 6.79201L6.87704 6.87704V12.7121C6.87699 12.8705 6.81682 13.023 6.70868 13.1387C6.60054 13.2545 6.4525 13.3248 6.29446 13.3356C6.13643 13.3464 5.98019 13.2968 5.85732 13.1969C5.73444 13.0969 5.65409 12.954 5.6325 12.7971L5.62667 12.7121V6.87704C5.62667 6.71123 5.69253 6.55221 5.80978 6.43496C5.92702 6.31772 6.08604 6.25185 6.25185 6.25185ZM7.71062 1.25037C7.34452 1.25038 6.99181 1.38805 6.7225 1.63605C6.45319 1.88405 6.28698 2.22424 6.25685 2.5891L6.25185 2.70914H9.16938C9.16938 2.32225 9.01569 1.9512 8.74212 1.67763C8.46855 1.40406 8.09751 1.25037 7.71062 1.25037Z"
                                    fill="black"
                                  />
                                </svg>
                              </Button>
                              <Button
                                variant="transparent"
                                className="border-0 p-0 btn"
                                onClick={() => showProductDetails(data)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="23"
                                  height="22"
                                  viewBox="0 0 23 22"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_0_1826)">
                                    <path
                                      d="M21.3845 10.7662C20.5759 8.67463 19.1721 6.8658 17.3467 5.56331C15.5212 4.26082 13.3541 3.52177 11.1132 3.4375C8.87234 3.52177 6.70525 4.26082 4.87981 5.56331C3.05437 6.8658 1.65059 8.67463 0.841983 10.7662C0.787373 10.9173 0.787373 11.0827 0.841983 11.2338C1.65059 13.3254 3.05437 15.1342 4.87981 16.4367C6.70525 17.7392 8.87234 18.4782 11.1132 18.5625C13.3541 18.4782 15.5212 17.7392 17.3467 16.4367C19.1721 15.1342 20.5759 13.3254 21.3845 11.2338C21.4391 11.0827 21.4391 10.9173 21.3845 10.7662ZM11.1132 17.1875C7.46948 17.1875 3.61948 14.4856 2.22386 11C3.61948 7.51437 7.46948 4.8125 11.1132 4.8125C14.757 4.8125 18.607 7.51437 20.0026 11C18.607 14.4856 14.757 17.1875 11.1132 17.1875Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M11.1133 6.875C10.2974 6.875 9.49991 7.11693 8.82156 7.57019C8.1432 8.02345 7.61449 8.66769 7.30228 9.42143C6.99007 10.1752 6.90838 11.0046 7.06754 11.8047C7.22671 12.6049 7.61958 13.3399 8.19647 13.9168C8.77336 14.4937 9.50836 14.8866 10.3085 15.0457C11.1087 15.2049 11.9381 15.1232 12.6919 14.811C13.4456 14.4988 14.0898 13.9701 14.5431 13.2917C14.9964 12.6134 15.2383 11.8158 15.2383 11C15.2383 9.90598 14.8037 8.85677 14.0301 8.08318C13.2565 7.3096 12.2073 6.875 11.1133 6.875ZM11.1133 13.75C10.5694 13.75 10.0377 13.5887 9.58546 13.2865C9.13323 12.9844 8.78075 12.5549 8.57261 12.0524C8.36447 11.5499 8.31001 10.9969 8.41612 10.4635C8.52223 9.93005 8.78414 9.44005 9.16874 9.05546C9.55333 8.67086 10.0433 8.40895 10.5768 8.30284C11.1102 8.19673 11.6632 8.25119 12.1657 8.45933C12.6682 8.66747 13.0977 9.01995 13.3998 9.47218C13.702 9.92442 13.8633 10.4561 13.8633 11C13.8633 11.7293 13.5736 12.4288 13.0578 12.9445C12.5421 13.4603 11.8426 13.75 11.1133 13.75Z"
                                      fill="black"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_0_1826">
                                      <rect
                                        width="22"
                                        height="22"
                                        fill="white"
                                        transform="translate(0.113281)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* <div className="d-flex align-items-center justify-content-between gap-10 flex-wrap mt-3 paginationWrpper mt-2 bg-white pt-3 ">
                <div className="left">
                  <div className="showResult d-flex align-items-center gap-10">
                    <label htmlFor="" className="form-label m-0">
                      Show Result:
                    </label>
                    <Form.Select
                      aria-label="Default select example"
                      value={filter.limit}
                      onChange={(e) => setFilter({ limit: e.target.value })}
                    >
                      {[10, 20, 30, 50]?.map((itm) => (
                        <option value={itm}>{itm}</option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                <div className="right ">
                  <Pagination>
                    <Pagination.Prev onClick={handlePreviousClick} />
                    {Array.from(Array(totalPage).keys())?.map((page, index) => {
                      var pageNo = page + 1;
                      return (
                        <Pagination.Item
                          active={pageNo == filter.page}
                          onClick={() => setFilter({ page: pageNo })}
                        >
                          {pageNo}
                        </Pagination.Item>
                      );
                    })}

                    <Pagination.Next onClick={handleNextClick} />
                  </Pagination>
                </div>
              </div> */}

              <CustomPagination
                totalPage={totalPage}
                setFilter={setFilter}
                filter={filter}
              />
            </div>
          </Row>
        </Container>
      </section>
      <ConfirmDelete
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        confirmDelete={confirmDelete}
        loading={showButtonLoader}
      />
    </Fade>
  );
};

export default Productcategory;
